import { useParams } from "react-router-dom";
import EventOrders from "../../components/UnifiedSearchList/EventOrders/EventOrders";
import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

export default function AllOrdersPage() {
  const { uuid } = useParams();

  return (
    <PaginationProvider>
      <ModalProvider>
        <EventOrders uuid={uuid} />
      </ModalProvider>
    </PaginationProvider>
  );
}
